import React from "react";
import SectionHeader from "./sectionheader";
import { Link, useNavigate } from "react-router-dom";

// const subtitle = <h4>BAT Events!</h4>;
const title = <h2 data-description="title">Join BAT Matrimony</h2>;
const subtitle = <h2 data-description="title">Coming Soon!</h2>
//const alignment = "section-header";
const alignment = "section-header";

const AboutSection = () => {
  return (
    <>
      <section className="about-section padding-tb bg-flower-img BAT-event-section bg-dark-sandal">
        <div className="container">
          <SectionHeader
            title={title}
            alignment={alignment}
          />
          <div className="section-wrapper">  
            <div className="row justify-content-center g-3 g-md-4 align-items-center d-flex">
              <div className="col-12 col-md-6 d-flex align-items-stretch">
                <img
                  src="assets/images/bat-img/join-mm.jpg"
                  alt="Join Matrimony"
                  className="img-fluid w-100 h-100 join-mm-img"
                />
              </div>
              <div className="col-12 col-md-6 d-flex align-items-stretch">
                <div className="right-content w-100">
                  <div className="section-wrapper bg-white h-100 d-flex flex-column justify-content-center p-4">
                    <div className="counters shadow-lg">
                      <p className="join-mm mb-10">
                        BAT Membership offers free matrimony services exclusively for
                        member's own children.{" "}
                        <Link to="/join-bat">Click here to become a Member.</Link> Or if you
                        are already a member, <Link to="/login">login</Link> to avail
                        Matrimony services.
                      </p>
                      <p className="join-mm mb-10">
                        Only interested in Matrimony services? Create an account to get
                        started:
                      </p>
                      <button className="button login-btn mt-20">
                        <Link to="/register">Create an account</Link>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        
            {/* <div className="row justify-content-center g-4">
              {AboutContentList.map((val, i) => (
                <div className="col-xl-3 col-lg-4 col-sm-6 col-12" key={i}>
                  <div className="lab-item about-item">
                    <div className="lab-inner text-center">
                      <div className="lab-thumb">
                        <img src={`${val.imgUrl}`} alt={`${val.imgAlt}`} />
                      </div>
                      <div className="lab-content">
                        <h2 className="counter">{val.countNumber}</h2>
                        <p>{val.countTitle}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <div className="video-container">
                <div className="video">
                  <SectionHeader
                    alignment={alignment}
                  />
                  <img
                    src="./assets/images/bat-img/video.svg"
                    alt="video"
                    className="shadow-lg"
                  />
                  <iframe
                    className="shadow-lg"
                    width="800"
                    height="450"
                    src="https://www.youtube.com/embed/2OkVmGpY0rM?si=SSuFpIbzquXEnbLq"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
      <div className="section-break"></div>
    </>
  );
};

export default AboutSection;
